<script lang="ts" setup>
  interface Props {
    maxValue: number
    disabled?: boolean
  }

  defineProps<Props>()
  const quantity = defineModel<number>({ required: true })
</script>

<template>
  <NInputNumber
    v-model:value="quantity"
    :min="1"
    :max="maxValue"
    :disabled="disabled"
    button-placement="both"
    round
    class="text-center [&_.n-input]:w-auto!"
    data-testid="shop-items-quantity"
  />
</template>
